(function() {
    angular.module('emarket.main.post').directive('emPremiumProductList', function() {
        return {
            scope: {
                premiumPost: '=',
                onOpen: '&'
            },
            controller: 'PremiumProductListController as vm',
            templateUrl: 'main/post/premium-product-list/premium.product.list.tpl.html'
        };
    });
}());
